import React from 'react'
import { observer } from 'mobx-react'
import Skeleton from 'react-loading-skeleton'
import { withTranslation } from 'react-i18next'

import { isMobileDevice } from '@flowwai-frontend/shared/utils/web'

import { WithTranslation } from '../../../types'

import { FullScreenLoader } from '../../LoadingWrapper/LoadingView'
import { REACT_LOADING_DURATION } from '../../Loader/constants'

import TaskManagementHeaderLoader from '../TaskManagementHeaderLoader'
import { ReactContentLoaderProps } from '../types'

import {
   YourTeamsLoadingWrapper,
   TeamLoadingWrapper,
   TeamsPrefixAndDisplayNameLoadingWrapper,
   ContentLoadingWrapper,
   TeamsListLoadingWrapper,
   YourTeamsRouteLoadingWrapper,
   TeamsRouteHeader,
   TeamsTitleLoader,
   YourTeamsBodyLoadingWrapper
} from './styledComponents'

interface TeamPropertyProps {
   displayNameWidth: number
   membersCount: number
}

interface YourTeamsRouteLoaderProps
   extends ReactContentLoaderProps,
      WithTranslation {
   isFromWithProjectsList?: boolean
}

class YourTeamsRouteLoader extends React.Component<YourTeamsRouteLoaderProps> {
   teamsProperties: TeamPropertyProps[] = [
      { displayNameWidth: 172, membersCount: 4 },
      { displayNameWidth: 160, membersCount: 3 },
      { displayNameWidth: 188, membersCount: 1 },
      { displayNameWidth: 178, membersCount: 2 },
      { displayNameWidth: 164, membersCount: 5 }
   ]
   renderTeamPrefixAndDisplayNameLoader = (displayNameWidth: number) => (
      <TeamsPrefixAndDisplayNameLoadingWrapper>
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={48}
            circle={true}
            height={48}
         />
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={displayNameWidth}
            height={16}
            style={{ marginLeft: 12 }}
         />
      </TeamsPrefixAndDisplayNameLoadingWrapper>
   )
   renderContentLoader = (membersCount: number) => (
      <ContentLoadingWrapper>
         <Skeleton
            duration={REACT_LOADING_DURATION}
            width={80}
            height={10}
            style={{ marginBottom: 8 }}
         />
         <Skeleton
            duration={REACT_LOADING_DURATION}
            circle={true}
            count={membersCount}
            width={32}
            height={32}
            style={{ marginRight: 8 }}
         />
      </ContentLoadingWrapper>
   )
   yourTeamListLoader = () => (
      <YourTeamsLoadingWrapper>
         {Array.from(this.teamsProperties).map(team => (
            <TeamLoadingWrapper key={team.membersCount}>
               {this.renderTeamPrefixAndDisplayNameLoader(
                  team.displayNameWidth
               )}
               {this.renderContentLoader(team.membersCount)}
            </TeamLoadingWrapper>
         ))}
      </YourTeamsLoadingWrapper>
   )
   renderTeamsRouteHeader = () => {
      const { t } = this.props
      return (
         <TeamsRouteHeader>
            <TeamsTitleLoader>
               {t('workflowManagement:yourTeams.yourTeams')}
            </TeamsTitleLoader>
         </TeamsRouteHeader>
      )
   }
   render() {
      if (isMobileDevice) {
         return <FullScreenLoader />
      }
      const {
         yourTeamListLoader: YourTeamListLoader,
         renderTeamsRouteHeader: RenderTeamsRouteHeader
      } = this
      const { isFromWithProjectsList } = this.props

      return (
         <YourTeamsRouteLoadingWrapper>
            {isFromWithProjectsList && <TaskManagementHeaderLoader />}
            <YourTeamsBodyLoadingWrapper>
               <TeamsListLoadingWrapper>
                  <RenderTeamsRouteHeader />
                  <YourTeamListLoader />
               </TeamsListLoadingWrapper>
            </YourTeamsBodyLoadingWrapper>
         </YourTeamsRouteLoadingWrapper>
      )
   }
}

export default withTranslation()(observer(YourTeamsRouteLoader))
